module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "ion-list",
    class: ['list-' + theme]
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-137c3dfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/src/list.vue
// module id = 152
// module chunks = 0